import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SUPPRESS_HTTP_ERROR_TOAST } from 'app/core/interceptors';
import { RedeemInvitationCodeRequest } from 'app/core/models';
import { environment } from 'src/environments';

/** The invitation-code API route prefix shared by client operations. */
export const INVITATION_CODE_API_ROUTE_PREFIX = 'invitation-codes';

const basePath = `${environment.apiBaseUrl}${INVITATION_CODE_API_ROUTE_PREFIX}`;

/** Provides invitation-code operations for the authenticated user. */
@Injectable({ providedIn: 'root' })
export class InvitationCodeApiClient {
  private readonly _http = inject(HttpClient);

  /** Redeems an invitation code for the authenticated user. */
  redeem(request: RedeemInvitationCodeRequest): Observable<void> {
    return this._http.post<void>(`${basePath}/redeem`, request, {
      context: new HttpContext().set(SUPPRESS_HTTP_ERROR_TOAST, true),
    });
  }
}
